export default [
    {
        path: "/admin/duty-post",
        component: () => import("@/App/Duty/DutyPost/Components/List.vue"),
        name: "duty-post",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/duty-post/create",
        component: () => import("@/App/Duty/DutyPost/Components/Create.vue"),
        name: "duty-post-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/admin/duty-post/:id/edit",
        component: () => import("@/App/Duty/DutyPost/Components/Edit.vue"),
        name: "duty-post-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
